module.exports = __webpack_public_path__ + "static/media/C (12).a0bf6cc4.jpg";